<template>
  <section class="ficha" v-if="epiPrepare">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="height-card position-relative px-2">
          <b-row class="my-2">
            <!-- Left: Product Image Container -->

            <b-col
              cols="12"
              lg="3"
              class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
            >
              <div
                class="d-flex align-items-center justify-content-center ficha-img"
              >
                <b-img
                  :alt="`Image of ${epi.name}`"
                  :src="imgEpi"
                  class="epi-img"
                  fluid
                />
              </div>
            </b-col>

            <!-- Right: Product Details -->
            <b-col cols="12" lg="9" class="ficha-info">
              <!-- Product Name -->
              <b-card-text class="item-company mb-0">
                <p class="ficha-info_serie mb-50" v-if="epi.serial_number && epi.serial_number != -1">
                  {{ epi.serial_number }}
                </p>
                <div class="border-bottom-light">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h2 class="ficha-info_name mb-50">{{ epi.name }}</h2>
                    <span
                      style="white-space: nowrap"
                      class="cursor-pointer"
                      @click="visibleInfo = !visibleInfo"
                    >
                      {{ $t("MasInfo") }}
                      <feather-icon
                        :icon="
                          visibleInfo ? 'ChevronUpIcon' : 'ChevronDownIcon'
                        "
                        size="20"
                      />
                    </span>
                  </div>
                  <b-collapse id="collapse" v-model="visibleInfo" class="mt-2">
                    <div>
                      <b-row>
                        <b-col md="6" sm="12">
                          <p class="mb-50" v-if="epi.product">
                            <span class="font-weight-bolder"
                            >{{ $t("codigoArticulo") }}:</span
                            >
                            <span v-if="epi.product.codart">{{ epi.product.codart }}</span>
                            <span v-else>-</span>
                          </p>
                        </b-col>
                        <b-col md="6" sm="12">
                          <p class="mb-50" v-if="epi.product">
                            <span class="font-weight-bolder"
                            >{{ $t("ean13") }}:</span
                            >
                            <span v-if="epi.product.ean13">{{ epi.product.ean13 }}</span>
                            <span v-else>-</span>
                          </p>
                        </b-col>
                        <b-col md="6" sm="12">
                          <p class="mb-50" v-if="epi.product">
                            <span class="font-weight-bolder"
                              >{{ $t("Modelo") }}:</span
                            >
                            {{ epi.product.modelo }}
                          </p>
                        </b-col>
                        <b-col md="6" sm="12">
                          <p class="mb-50" v-if="epi.product.category && epi.product.category.family">
                            <span class="font-weight-bolder"
                            >{{ $t("Categoria") }}:</span
                            >
                            {{ epi.product.category.name }}
                          </p>
                        </b-col>
                        <b-col md="6" sm="12" v-if="currentRole === 'admin_empresa'">
                          <p class="mb-50" v-if="epi.client">
                            <span class="font-weight-bolder"
                              >{{ $t("Cliente") }}:</span
                            >
                            {{ epi.client.name }}
                          </p>
                        </b-col>
                        <b-col cols="6" v-if="epi.pedido_num_id">
                          <p class="mb-50">
                            <span class="font-weight-bolder"
                            >{{ $t("NumeroAlbaran") }}:</span
                            >
                            {{ epi.pedido_num_id }}
                          </p>
                        </b-col>
                        <b-col cols="6" v-if="epi.coste">
                          <p class="mb-50">
                            <span class="font-weight-bolder"
                            >{{ $t("Coste") }}:</span
                            >
                            {{ priceFormatted(epi.coste) }} €
                          </p>
                        </b-col>
                        <b-col cols="12">
                          <div class="ficha-info_description mb-50 mt-1" v-if="epi.description != 'null'" v-html="epi.description" />
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
              </b-card-text>
              <div class="mb-2 mt-1">
                <b-badge
                  v-if="epi.status"
                  :variant="statusEpis[epi.status.alias]"
                  class="mr-50"
                >
                  {{ $t(`status.epis.${epi.status.alias}`) }}
                </b-badge>
                <b-badge v-if="epi.apto" variant="success">
                  {{ $t("APTO") }}
                </b-badge>
                <b-badge v-else variant="danger">
                  {{ $t("NO APTO") }}
                </b-badge>
              </div>
              <b-row
                class="mb-2"
                v-if="epi.status.alias == 'use' && epi.user"
              >
                <b-col cols="12" xl="4" md="6" class="mb-2">
                  <div class="bg-light-fade p-1 h-100">
                    <div class="">
                      <b-row class="">
                        <b-link
                          :to="{
                            name: 'viewUser',
                            params: { id: epi.user.id },
                          }"
                          class="mr-1"
                        >
                          <b-col cols="12" class="d-flex align-items-center">
                            <div class="pr-2">
                              <b-avatar
                                size="4rem"
                                :src="epi.user.avatar_url"
                              />
                            </div>
                            <div>
                              <h4 class="m-0 font-weight-bolder">
                                {{ epi.user.name }} {{ epi.user.surname }}
                              </h4>

                              <span
                                :key="r.display_name"
                                v-for="r in epi.user.roles"
                              >
                                {{ r.display_name }}
                              </span>
                            </div>
                          </b-col>
                        </b-link>
                      </b-row>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" xl="4" md="6" class="mb-2">
                  <div class="bg-light-fade p-1 h-100">
                    <p class="font-weight-bolder mb-0">
                      {{ $t("UltimaRevision") }}
                    </p>
                    <p class="mb-0" v-if="epi.last_review_date">{{ toDate(epi.last_review_date) }}</p>
                    <p class="mb-0" v-else>-</p>
                  </div>
                </b-col>
                <b-col cols="12" xl="4" md="6" class="mb-2">
                  <span v-if="epi.next_review_date && epi.next_review_date != 'null'">
                    <div
                      v-if="epi.next_review_date < nowTimestamp"
                      class="bg-danger-fade p-1 h-100"
                    >
                      <p class="font-weight-bolder mb-0">
                        {{ $t("ProximaRevision") }}
                      </p>
                      <p class="mb-0">{{ toDate(epi.next_review_date) }}</p>
                      <b-link 
                        v-if="epi.task_next_review_date"
                        :to="{
                          name: 'viewTask',
                          params: { id: epi.task_next_review_date.id },
                        }" 
                        class="link-blue truncated-text mt-1"
                      >
                        {{ epi.task_next_review_date.name }}
                        <feather-icon size="18" icon="ArrowRightIcon" />
                      </b-link>
                    </div>
                    <div
                        v-else
                        class="bg-light-fade p-1 h-100">
                          <p class="font-weight-bolder mb-0">
                            {{ $t("ProximaRevision") }}
                          </p>
                          <p class="mb-0">{{ toDate(epi.next_review_date) }}</p>
                    </div>
                  </span>
                  <span v-else>
                    <div class="bg-light-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">
                        {{ $t("ProximaRevision") }}
                      </p>
                      <p class="mb-0">-</p>
                    </div>
                  </span>
                </b-col>
                <b-col cols="12" xl="4" md="6" class="mb-2">
                  <div
                    class="bg-light-fade p-1 h-100"
                    v-if="epi.useful_review > 3"
                  >
                    <p class="font-weight-bolder mb-0">
                      {{ $t("TiempoRestante") }}
                    </p>
                    <p class="mb-0">
                      {{ epi.useful_review }} {{ $t("meses") }}
                    </p>
                  </div>
                  <div v-else-if="epi.useful_review === null">
                    <div class="bg-light-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">
                        {{ $t("TiempoRestante") }}
                      </p>
                      <p class="mb-0">
                        -
                      </p>
                    </div>
                  </div>
                  <div v-else-if="epi.useful_review === false">
                    <div class="bg-danger-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">
                        {{ $t("TiempoRestante") }}
                      </p>
                      <p v-if=" epi.useful_review" class="text-danger mb-0">
                        0 {{ $t("meses") }}
                      </p>
                      <p v-else class="mb-0">
                        -
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <div class="bg-danger-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">
                        {{ $t("TiempoRestante") }}
                      </p>
                      <p v-if=" epi.useful_review" class="text-danger mb-0">
                        {{ epi.useful_review }} {{ $t("meses") }}
                      </p>
                      <p v-else class="mb-0">
                        -
                      </p>
                    </div>
                  </div>

                </b-col>
                <b-col cols="12" xl="4" md="6" class="mb-2 d-lg-block d-none">
                  <div class="bg-light-fade p-1 h-100">
                    <p class="font-weight-bolder mb-0">
                      {{ $t("FechaCompra") }}
                    </p>
                    <p class="mb-0" v-if="epi.purchase_date">{{ toDate(epi.purchase_date) }}</p>
                    <p class="mb-0" v-else>-</p>
                  </div>
                </b-col>
                <b-col cols="12" xl="4" md="6" class="mb-2 d-lg-block d-none">
                  <div class="bg-light-fade p-1 h-100">
                    <p class="font-weight-bolder mb-0">
                      {{ $t("FechaCaducidad") }}
                    </p>
                    <p class="mb-0" v-if="epi.date_of_expiry">{{ toDate(epi.date_of_expiry) }}</p>
                    <p class="mb-0" v-else>-</p>
                  </div>
                </b-col>
                <b-col cols="12" xl="4" md="6" class="mb-2 d-lg-block d-none">
                  <div
                    class="bg-light-fade p-1 h-100"
                    v-if="epi.useful_life > 12"
                  >
                    <p class="font-weight-bolder mb-0">{{ $t("VidaUtil") }}</p>
                    <p class="mb-0">
                      {{ epi.useful_life }} {{ $t("meses") }}
                    </p>
                  </div>
                  <div v-else-if="epi.useful_life === null">
                    <div class="bg-light-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">{{ $t("VidaUtil") }}</p>
                      <p class=" mb-0">
                        -
                      </p>
                    </div>
                  </div>
                  <div v-else-if="epi.useful_life === 0">
                    <div class="bg-light-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">{{ $t("VidaUtil") }}</p>
                      <p class=" mb-0">
                        {{ epi.useful_life }} {{ $t("meses") }}
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <div class="bg-danger-fade p-1 h-100">
                      <p class="font-weight-bolder mb-0">{{ $t("VidaUtil") }}</p>
                      <p class="text-danger mb-0">
                        {{ $t("Caducado") }}
                      </p>
                    </div>
                  </div>

                </b-col>
                <b-col cols="12">
                  <div class="mb-1">
                    <p class="font-weight-bolder mb-50">
                      {{ $t("DocumentosFabricante") }}
                    </p>
                    <!--  <b-link
                        v-if="epi.product.docs.manualUso"
                        :href="epi.product.docs.manualUso"
                        target="_blank"
                        class="mr-1 mb-1 link"
                    >
                      {{ $t('manualUso') }}
                    </b-link> -->
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      v-if="epi.product.docs.manualUso"
                      :href="epi.product.docs.manualUso"
                      target="_blank"
                      style="margin-right: 10px"
                    >
                      <feather-icon icon="FileIcon" class="mr-50" size="16" />
                      <span class="align-middle"> {{ $t("manualUso") }}</span>
                    </b-button>
                    <p class="font-weight-bolder mb-50 d-block d-lg-none"></p>
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      v-if="epi.product.docs.fichaTecnica"
                      :href="epi.product.docs.fichaTecnica"
                      target="_blank"
                      style="margin-right: 10px"
                    >
                      <feather-icon icon="FileIcon" class="mr-50" size="16" />
                      <span class="align-middle">
                        {{ $t("fichaTecnica") }}</span
                      >
                    </b-button>
                    <!--     <b-link
                        v-if="epi.product.docs.fichaTecnica"
                        :href="epi.product.docs.fichaTecnica"
                        target="_blank"
                        class="mr-1 mb-1 link"
                    >
                      {{ $t('fichaTecnica') }}
                    </b-link> -->
                    <p class="font-weight-bolder mb-50 d-block d-lg-none"></p>
                    <!--   <b-link
                        v-if="epi.product.docs.certificadoConformidad"
                        :href="epi.product.docs.certificadoConformidad"
                        target="_blank"
                        class="mr-1 mb-1 link"
                    >
                      {{ $t('certificadoConformidad') }}
                    </b-link> -->
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      v-if="epi.product.docs.certificadoConformidad"
                      :href="epi.product.docs.certificadoConformidad"
                      target="_blank"
                    >
                      <feather-icon icon="FileIcon" class="mr-50" size="16" />
                      <span class="align-middle">
                        {{ $t("certificadoConformidad") }}</span
                      >
                    </b-button>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="mb-1">
                    <p class="font-weight-bolder mb-50">
                      {{ $t("DocumentosTrazabilidad") }}
                    </p>
                    <!--   <b-link
                      v-if="epi.archives && epi.archives.review"
                      :href="epi.archives.review.url"
                      target="_blank"
                      class="mr-1 mb-1 link"
                    >
                      {{ $t('Certificado revisión') }}
                    </b-link> -->
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      v-if="epi.archives && epi.archives.review"
                      :href="epi.archives.review.url"
                      target="_blank"
                      style="margin-right: 10px"
                    >
                      <feather-icon icon="FileIcon" class="mr-50" size="16" />
                      <span class="align-middle">
                        {{ $t("Certificado revisión") }}</span
                      >
                    </b-button>
                    <span v-else>-</span>
                    <p class="font-weight-bolder mb-50 d-block d-lg-none"></p>
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      v-if="canDownload && fileDownload"
                      :href="fileDownload"
                      target="_blank"
                      class="word-break-all"
                    >
                      <feather-icon icon="FileIcon" class="mr-50" size="16" />
                      <span class="align-middle"> {{ textDownload }}</span>
                    </b-button>
                    <!-- <b-link
                      v-if="canDownload && fileDownload"
                      :href="fileDownload"
                      target="_blank"
                      class="mr-1 mb-1 link"
                    >
                      {{ textDownload }}
                    </b-link> -->
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4" class="ficha-tag d-lg-block d-none">
        <b-card no-body class="height-card">
          <div class="p-2" v-if="epi.tag">
            <h5 class="mb-1 font-weight-bolder">{{ $t("QR") }}</h5>
            <div class="text-center mb-2">
              <img :src="epi.tag.image_url" class="img-fluid" />
            </div>
            <p class="mb-50" v-if="epi.tag.last_scan">
              <span class="font-weight-bolder"
                >{{ $t("UltimoRegistro") }}:</span
              >
              {{ toDateWithTime(epi.tag.last_scan) }}
            </p>
            <p class="mb-50">
              <span class="font-weight-bolder"
                >{{ $t("TotalRegistros") }}:</span
              >
              {{ epi.tag.total_scans }}
            </p>
          </div>
        </b-card>
      </b-col>
      <!--   <b-col cols="12" lg="8" class="ficha-localizacion d-lg-block  d-none"> -->
      <b-col cols="12" lg="8" class="ficha-localizacion d-lg-block">
        <b-card no-body class="height-card">
          <div class="py-1 px-2">
            <h5 class="mb-1 font-weight-bolder">{{ $t("Localizacion") }}</h5>
            <p class="mb-1" v-if="locActual">{{ epi.location }}</p>
            <!--   <div class="mb-1" v-else>
              <p class="mb-50">{{ $t("Evento") }}: {{ textEventLoc }}</p>
              <span class="link cursor-pointer" @click="setData()">{{
                $t("VerLocalizacionActual")
              }}</span>
            </div> -->
            <div v-if="latitude && longitude">
              <l-map :zoom="zoom" :center="center">
                <l-tile-layer :url="url" />
                <l-marker :lat-lng="[latitude, longitude]" />
              </l-map>
            </div>
          </div>
        </b-card>
      </b-col>
      <!--  <b-col
        cols="12"
        class="ficha-mantenimiento d-lg-block d-none"
        v-if="items.length"
      > -->
      <b-col
        cols="12"
        class="ficha-mantenimiento d-lg-block"
      >
        <b-card no-body>
          <b-row>
            <b-col sm="12" md="10">
              <b-tabs
                  style="font-weight: bolder"
                  lazy pills
                  nav-class="flex-column flex-md-row"
                  :align="(['xs', 'sm'].includes(breakpoint)) ? 'center' : 'start'"
                  @activate-tab="tab = $event"
              >
                <b-tab :active="tab === 0">
                  <template #title>
                    {{ $t("Actions") }}
                  </template>
                </b-tab>
                <b-tab :active="tab === 1">
                  <template #title>
                    {{ $t("NextActions") }}
                  </template>
                </b-tab>
                <b-tab :active="tab === 2">
                  <template #title>
                    {{ $t("ExternalActions") }}
                  </template>
                </b-tab>
              </b-tabs>
            </b-col>
            <b-col
                sm="12"
                md="2"
                class="d-flex justify-content-end align-self-center pr-2"
                :class="{ 'py-1': ['xs', 'sm'].includes(breakpoint) }"
            >
              <div v-if="tab === 2 && (currentRole === 'admin_empresa' || currentRole === 'admin_cliente' || currentRole === 'super_admin')">
                <b-button
                    @click="externalActionModal = true"
                    variant="outline-primary"
                    size="sm"
                >
                  <span> {{ $t("AddAction") }}</span>
                </b-button>
              </div>
              <div v-else class="d-flex" >
                <span v-if="['xs', 'sm'].includes(breakpoint)" style="margin-right: 5px">
                  {{ $t("Filters") }}
                </span>
                <feather-icon
                  class="mr-1 cursor-pointer d-flex align-self-center"
                  icon="FilterIcon"
                  size="20"
                  @click="visibleFilter = !visibleFilter"
                />
              </div>
            </b-col>
          </b-row>
          <template v-if="tab === 0">
            <ActionsTable :visibleFilter="visibleFilter" type="epi" />
          </template>
          <template v-if="tab === 1">
            <NextActionsTable :visibleFilter="visibleFilter" type="epi" />
          </template>
          <template v-if="tab === 2">
            <ExternalActionsTable type="epi" />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <CreateExternalActionModal v-model="externalActionModal" object_type="epi" />
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BCardText,
  BLink,
  BButton,
  BBadge,
  BTable,
  BCollapse,
  BPagination,
  BAvatar,
  BFormGroup, BTab, BTabs,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { isUserLoggedIn } from "@/auth/utils";
import { config } from "@/shared/app.config";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";
import { latLng, Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import {
  TimestampToFlatPickr,
  TimestampToFlatPickrWithTime,
} from "@/libs/helpers";
import SelectUsers from "@/components/selectUsers/SelectUsers";
import ActionsTable from "@/components/actions/table/ActionsTable.vue";
import NextActionsTable from "@/components/actions/table/NextActionsTable.vue";
import CreateExternalActionModal from "@/components/actions/modal/CreateExternalActionModal.vue"
import ExternalActionsTable from "@/components/actions/table/ExternalActionsTable.vue";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    NextActionsTable, BTabs, ExternalActionsTable, ActionsTable, BTab,
    SelectUsers,
    BRow,
    BCol,
    BCard,
    BImg,
    BCardText,
    BBadge,
    BTable,
    BLink,
    BButton,
    LMap,
    LTileLayer,
    LMarker,
    BCollapse,
    BPagination,
    BAvatar,
    BFormGroup,
    CreateExternalActionModal
  },
  directives: {
    Ripple,
  },
  mounted() {
    this.stacked = window.innerWidth <= 1400;
    window.addEventListener("resize", () => {
      this.stacked = window.innerWidth <= 1400;
    });
  },
  data() {
    return {
      tab: 0,
      currentPage: 1,
      pages: ["10", "15", "25"],
      pageLength: 10,
      user: null,
      visibleInfo: false,
      statusEpis: config.statusEpisVariants,
      stacked: false,
      visibleFilter: false,
      nowTimestamp: Math.floor(Date.now() / 1000),
      fieldsMantenimiento: [
        { key: "created_at", label: this.$t("Fecha") },
        { key: "created_at_hour", label: this.$t("Hora") },
        { key: "type", label: this.$t("Evento") },
        { key: "assign_user", label: this.$t("Usuario") },
        { key: "user", label: this.$t("Responsable") },
        /*   { key: 'user_roles', label: this.$t('Rol') }, */
        { key: "status", label: this.$t("Estado") },
        { key: "location", label: this.$t("Localizacion") },
        { key: "actions", label: this.$t("Acciones"), class: "text-right" },
      ],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      urlLocation: "",
      zoom: 13,
      zoomLocation: 5,
      latitude: 0,
      longitude: 0,
      locActual: true,
      textEventLoc: "",
      epiPrepare: false,
      externalActionModal: false,
    };
  },
  computed: {
    ...mapGetters({
      epi: "epis/getEpi",
      items: "events/getItemsLogs",
      totalItems: "events/getTotalItemsLogs",
      currentRole: 'auth/getRole',
      breakpoint: "app/currentBreakPoint",
    }),
    canDownload() {
      if (this.epi && this.epi.status) {
        if (
          this.epi.status.alias === "incidence" ||
          this.epi.status.alias === "use"
        ) {
          return true;
        }
      }
      return false;
    },
    fileDownload() {
      if (this.epi && this.epi.status) {
        if (
          this.epi.status.alias === "incidence" &&
          this.epi.archives.incidence
        ) {
          return this.epi.archives.incidence.url;
        } else if (
          this.epi.status.alias === "use" &&
          this.epi.archives.delivery
        ) {
          return this.epi.archives.delivery.url;
        }
      }
      return false;
    },
    textDownload() {
      if (this.epi && this.epi.status) {
        if (
          this.epi.status.alias === "incidence" &&
          this.epi.archives.incidence
        ) {
          return this.$t("InformeIncidencia");
        } else if (
          this.epi.status.alias === "use" &&
          this.epi.archives.delivery
        ) {
          return this.$t("CertificadoEntrega");
        }
      }
      return "";
    },
    center() {
      return latLng(this.latitude, this.longitude);
    },
    imgEpi() {
      if (this.epi.product) {
        return this.epi.product.docs.imagen
      }
      return "";
    },
    isLogin() {
      return isUserLoggedIn();
    },
  },
  watch: {
    currentPage() {
      this.chargeData();
    },
    pageLength() {
      this.chargeData();
    },
    user() {
      this.currentPage = 1;
      this.chargeData();
    },
  },
  methods: {
    ...mapActions({
      getEpi: "epis/getEpi",
      getListLogs: "events/getListLogs",
    }),
    toDate(f) {
      if (f) {
        return TimestampToFlatPickr(f);
      }
      return "";
    },
    toDateWithTime(f) {
      if (f) {
        return TimestampToFlatPickrWithTime(f);
      }
      return "";
    },
    chargeData() {
      this.getListLogs({
        id: this.$route.params.id,
        page: this.currentPage,
        per_page: this.pageLength,
        search: this.searchTerm,
        user: this.user?.id,
        type_object: 'epi'
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.chargeData();
    },
    openMap(latitude, longitude, text, hour) {
      this.latitude = latitude;
      this.longitude = longitude;
      this.locActual = false;
      this.textEventLoc = `${text} - ${hour}`;
    },
    setData() {
      if (this.epi.location_relation) {
        this.latitude = this.epi.location_relation.latitude;
        this.longitude = this.epi.location_relation.longitude;
      } else {
        this.latitude = "";
        this.longitude = "";
      }
      this.locActual = true;
      this.epiPrepare = true;
    },
    handleOpenMapLinkClick(epi) {
      this.openMap(
        epi.location?.latitude || epi.latitude,
        epi.location?.longitude || epi.longitude,
        this.$t(`typeevents.${epi.type}`),
        this.toDateWithTime(epi.created_at),
      )
    },
    priceFormatted(price) {
      let val = (price / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
  },
  async created() {
    await this.getEpi(this.$route.params.id);
    await this.setData();
    await this.chargeData();
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
